import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithReauth } from "../../Services/Basequerywithreauth";

export const truckingService = createApi({
  reducerPath: "truckingService",
  baseQuery: createBaseQueryWithReauth(),
  endpoints: (builder) => ({
    getTripsList: builder.query({
      query: (params) => ({
        url: "trip-view-list",
        params,
      }),
    }),
    getIncomingFlightList: builder.query({
      query: (params) => ({
        url: "trucker/incoming-flights",
        params,
      }),
    }),
  }),
});

export const {
  useGetTripsListQuery,
  useGetIncomingFlightListQuery
} = truckingService;
